import { reconcileConfigIds } from 'components/equipment-page/equipment-filter-conversion';
import { ActiveTabType, ConfigurationType } from 'data/types';

type FullFetchScopeArgs = {
  activeTab: ActiveTabType;
  /** `state.ui.equipmentFilters.configIds` — `null` means every configuration. */
  configIds: string[] | null;
  configurations: ReadonlyArray<ConfigurationType>;
};

/**
 * Which configurations the full (scored, combined) valid-systems request
 * should run for; `null` means all of them.
 *
 * On Choose Systems the per-configuration checkboxes are the `configIds`
 * equipment filter, applied client-side: an unchecked configuration is not
 * shown in the comparison and its universe/counts are excluded from the
 * filter panel, so re-running its full request on every filter change is
 * wasted work. It is re-requested as soon as it is checked again, because
 * its request hash (built with the current filters) no longer matches the
 * last one it fetched. The air-handler options (pool) request is not scoped
 * here — it serves the configuration cards on every page.
 *
 * Outside Choose Systems the checkboxes have no meaning, so every
 * configuration stays in scope and the Configurations page keeps refreshing
 * its systems lists as before.
 */
export function fullFetchConfigScope({
  activeTab,
  configIds,
  configurations
}: FullFetchScopeArgs): ReadonlySet<string> | null {
  if (activeTab !== 'chooseSystems' || configIds === null) return null;
  return reconcileConfigIds(
    configIds,
    configurations.map((configuration) => configuration.uniqueId)
  );
}
